import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import styled, { useTheme } from 'styled-components'
import { HorizontalCardDescription } from '@velasca/ui/horizontal-card-description'
import { HorizontalCardTitle } from '@velasca/ui/horizontal-card-title'
import {
  Background,
  Card,
  Details,
  ImageWrapper,
  LoadingButton,
  LoadingImage,
  Separator,
} from './SuggestedHorizontalProduct.styles'

const StyledSkeleton = styled(Skeleton)`
  font-size: inherit;

  span {
    font-size: inherit;
  }
`

interface SuggestedHorizontalProductSkeletonProps {
  isQuickAdd?: boolean
}

export const SuggestedHorizontalProductSkeleton = ({
  isQuickAdd = true,
}: SuggestedHorizontalProductSkeletonProps): JSX.Element => {
  const theme = useTheme()

  return (
    <SkeletonTheme
      baseColor={theme.colors.secondary}
      highlightColor={theme.colors.disabled}
    >
      <Background>
        <Card>
          <ImageWrapper>
            <LoadingImage />
          </ImageWrapper>

          <Details>
            <HorizontalCardTitle>
              <StyledSkeleton width="6rem" />
            </HorizontalCardTitle>
            <HorizontalCardDescription>
              <StyledSkeleton width="10rem" />
            </HorizontalCardDescription>
            <HorizontalCardDescription>
              <StyledSkeleton width="6rem" />
            </HorizontalCardDescription>
            <StyledSkeleton width="3rem" />
          </Details>
        </Card>

        {isQuickAdd && (
          <>
            <Separator />
            <LoadingButton>
              <Skeleton inline width="10rem" height="1.6rem" />
            </LoadingButton>
          </>
        )}
      </Background>
    </SkeletonTheme>
  )
}
